import React, { PropsWithChildren, ReactNode } from "react";
import classes from "./Card.module.scss";
type CardProps = {
  withoutborder? : boolean;
  cardClasses?: string;
  children:ReactNode;
}

const Card = ({ withoutborder = false, cardClasses = '' ,...props}:CardProps) => {
  console.log(props);
  
  
  return <div className={classes.card + `${withoutborder ? '!border-none':''} ${' '+ cardClasses}`}>{props.children}</div>;
};

export default Card;
